// @flow

import { CollapseHeader, Wrap } from "./Accordion.styles";
import { Link } from "react-router-dom";
import { Typography } from "antd";
import Collapse from "@kunukn/react-collapse";
import Icon, { Icons } from "react-hp-icons";
import React, { type Node, useState } from "react";
import theme from "views/resources/theme";
import { useQuery } from "hooks/useQuery";
import { useCurrentBreakpointName } from "react-socks";

interface Props {
	open?: boolean;
	header: ?Node;
	children: Node;
	footer?: ?Node;
	headerStyle?: Object;
	alwaysOpen?: boolean;
}

export const Accordion2 = ({
	open = false,
	header = "",
	children,
	footer,
	headerStyle = {},
	alwaysOpen = false,
}: Props) => {
	const [isOpen, setOpen] = useState(open || alwaysOpen);
	const toggleOpen = () => setOpen(!isOpen || alwaysOpen);

	return (
		<div>
			<CollapseHeader
				onClick={toggleOpen}
				isOpen={isOpen}
				style={headerStyle}
			>
				<h3>{header}</h3>
				{!alwaysOpen && (
					<Icon type={Icons.left} color={theme.colors.fg} size={1} />
				)}
			</CollapseHeader>
			<Wrap isOpen={isOpen}>
				<Collapse isOpen={isOpen}>{() => children}</Collapse>
			</Wrap>
			{!isOpen && footer}
		</div>
	);
};

const Accordion = ({
	officeSlug = "",
	open = false,
	header = "",
	children,
	footer,
	slug,
	headerStyle = {},
	frozen,
	alwaysOpen = false,
}: Props) => {
	const query = useQuery();
	const temporary = query.get("temporary");
	const toggleOpen = () => {};
	const route = temporary
		? `${officeSlug}/lines/${slug}?temporary=true`
		: `${officeSlug}/lines/${slug}`;
	const currentBp = useCurrentBreakpointName();

	return (
		<div style={{ height: 90 }}>
			<Link to={route}>
				<CollapseHeader
					frozen={frozen}
					onClick={toggleOpen}
					style={headerStyle}
				>
					<h3
						style={
							currentBp === "mobile" ? { fontSize: "15px" } : {}
						}
					>
						{header}
					</h3>
				</CollapseHeader>
				{footer}
			</Link>
		</div>
	);
};

export default Accordion;
